module.exports = __webpack_public_path__ + "img/00040.a12eeab4.webp";